
(function () {
    'use strict';

    angular.module(modules.homeModule)
        .controller('MainPageController', mainPageController);

    mainPageController.$inject = ['$scope', '$http', '$window', '$uibModal', '$location', 'hotkeys', 'resizeService',
        'broadcastService', 'tabStateService', 'shortcutKeysService', 'localStorageService', 'npDialog',
        'helpPagesService', '$sce', 'configService', 'commonService', '$q'];

    function mainPageController($scope, $http, $window, $uibModal, $location, hotkeys, resizeService,
        broadcastService, tabStateService, shortcutKeysService, localStorageService, npDialog,
        helpPagesService, $sce, configService, commonService, $q) {
        var vm = this;
        vm.translation = {
            aboutNetpowerHandbook: globalResources.About + ' ' + globalResources.NetpowerHandbook,
            changePassword: globalResources.ChangePassword,
            userManual: globalResources.UserManual
        };

        var urlParams = $location.url().split('/');
        vm.isEmbedUrl = false;
        vm.isHearingUrl = false;
        vm.isFolderUrl = false;
        vm.isDocumentUrl = false;
        vm.isMainUrl = false;
        if (urlParams != null && urlParams.length) {
            vm.isMainUrl = urlParams[1] == '';
            vm.isEmbedUrl = (urlParams[1] == 'embed' || urlParams[1] == 'annualCycle');
            vm.isFolderUrl = urlParams[1] == 'folder';
            vm.isDocumentUrl = urlParams[1] == 'document';
            vm.isHearingUrl = ((urlParams[3] == 'hearing') || (urlParams[3] == 'hearingfields') || urlParams[3] == 'compareWithEarlierVersion') || (urlParams[3] == 'viewsendtohearing');
        }

        vm.rememberedChangedWidth = 0;
        vm.userId = user.userId;
        vm.annualCycleHomeUrl = new URL('annualCycle/home', HandbookConfiguration.BackendURL).href;
        vm.isTest = configService.getBool(HandbookConfiguration.IsTest);
        vm.enabledAnnualCycle = configService.getBool(HandbookConfiguration.EnabledAnnualCycle);
        vm.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);
        vm.publicAlert = HandbookConfiguration.PublicAlert;
        vm.activityPopupSize = parseInt(HandbookConfiguration.ActivityPopupSize);
        vm.sidebarAdjustmentWidth = sidebarAdjustmentWidth;
        vm.autoHideSidebar = autoHideSidebar;
        vm.openMyReadingReceipt = openMyReadingReceipt;
        vm.changePassword = changePassword;
        vm.showStartpageImage = configService.getBool(HandbookConfiguration.ShowStartpageImage);
        vm.setMasterTab = setMasterTab;
        vm.changeFontsizeGuide = globalResources.ChangeFontsizeMessage;
        vm.toggleActivities = toggleActivities;
        vm.editActivity = editActivity;
        vm.stopPropagation = stopPropagation;
        vm.openAboutDialog = openAboutDialog;
        vm.changeColor = changeColor;
        vm.changeLanguage = changeLanguage;
        vm.keydown = keydown;
        vm.helpEnabled = configService.getBool(HandbookConfiguration.HelpEnabled);
        vm.goToHelpPages = goToHelpPages;
        vm.showSearchBoxHeader = false;
        vm.toggleSearchBox = toggleSearchBox;
        vm.LANGUAGES = LANGUAGES;
        vm.annualCyclePermissions = null;

        vm.currentActivityNotifyTab = 0 // 0: active tab	1: upcoming tab
        vm.onChangeActivityNotifyTab = onChangeActivityNotifyTab;
        let currentPageIndexNotifyAc = 1;
        vm.activitiesNotify = [];
        
        vm.activeActivityCounter = 0;
        vm.calendarLoading = false;
        vm.calendarChangeTabLoading = false;
        vm.calendarLoadingMore = false;

        initialize();

        function initialize() {
            vm.currentLanguage = commonService.getCurrentLanguageText();

            vm.changeFontsizeGuide = $sce.trustAsHtml(String.format('<div class="changeFontsizeDlg"><div>{0}</div></div>', vm.changeFontsizeGuide));
            if (vm.enabledAnnualCycle) {
                getActiveActivitiesForNotificationCounter();
            }

            if (vm.isTest) {
                updatePositionForTestModeHeader();
            }

            var hasShownPublicAlert = localStorageService.getItem(hasShownPublicAlertKeyStorage);
            if (vm.publishedVersion && vm.publicAlert && !hasShownPublicAlert) {
                npDialog.showDialog(
                    {
                        type: dialogTypes.OK,
                        message: vm.publicAlert,
                        title: globalResources.Information
                    }, function () { });
                localStorageService.setItem(hasShownPublicAlertKeyStorage, true);
            }
        }

        $(document).bind('click', function (event) {
            var isClickedElementChildOfPopup = $('#dropdownusername')
                .find(event.target)
                .length > 0;

            if (isClickedElementChildOfPopup)
                return;
            vm.showDropdownTopbar = false;
            angular.element('#dropdownusername').removeClass('open');
            $scope.$apply();
        });

        function toggleSearchBox() {
            vm.showSearchBoxHeader = !vm.showSearchBoxHeader;
            setTimeout(function () {
                tabStateService.adjustContentHeightPosition(tabStateType.documentTabState);
            }, 0)
        }

        function changeColor() {
            if (vm.showDropdownTopbar) {
                angular.element('#dropdownusername').addClass('open');
            } else {
                angular.element('#dropdownusername').removeClass('open');
            }
        };

        function changeLanguage(language) {
            $http.post(handbookRequests.ChangeLanguage,
                {
                    language: language
                }).then(function (data, status, headers, config) {
                    vm.currentLanguage = commonService.getCurrentLanguageText();
                    user.language = vm.currentLanguage;
                    var hasShownPublicAlert = localStorageService.getItem(hasShownPublicAlertKeyStorage);
                    localStorageService.clearAll();
                    if (hasShownPublicAlert) {
                        localStorageService.setItem(hasShownPublicAlertKeyStorage, hasShownPublicAlert);
                    }
                    location.reload();
                });
        };

        function setMasterTab() {
            tabStateService.setState(tabStateType.homeTabState, homeTabs.startPage);
        }

        function sidebarAdjustmentWidth() {
            if ($window.innerWidth > 980) {
                _setWidthWhenLargerThan980px();
            }
            else {
                _setWidthWhenSmallerThan980px();
            }

            broadcastService(broadcastType.toggleSidebar, $scope.toggleSidebar);
        };

        $scope.$on(broadcastType.hideSidebarInMobileWhenOpenDocument, function (e, target) {
            $scope.toggleSidebar = !$scope.toggleSidebar;
            sidebarAdjustmentWidth();
            setTimeout(() => {
                angular.element('#document-content-information-id').css('paddingLeft', '0px');
            }, 0);
        });

        function autoHideSidebar() {
            if ($window.innerWidth < 960 && angular.element('#sidebar-wrapper').hasClass('toggle-sidebar')) {
                angular.element('#sidebar-wrapper').removeClass('toggle-sidebar');
                angular.element('#resizeBar').removeClass('toggle-sidebar');
                angular.element('#wrapper').removeClass('toggle-wrapper');
                angular.element('.tabbable').removeClass('toggle-mainview');
                $scope.toggleSidebar = false;
            }
        };

        function _setWidthWhenLargerThan980px() {
            if (angular.element('#sidebar-wrapper').hasClass('toggle-sidebar')) {
                _resizeSidebarWithRememberedChangedWidth();
            }
            else {
                _rememberWidthChangedAndResizeToOrginalSize();
            }
        };

        function _setWidthWhenSmallerThan980px() {
            if (angular.element('#sidebar-wrapper').hasClass('toggle-sidebar')) {
                _rememberWidthChangedAndResizeToOrginalSize();
            }
            else {
                _resizeSidebarWithRememberedChangedWidth();
            }
        };

        function _rememberWidthChangedAndResizeToOrginalSize() {
            vm.rememberedChangedWidth = angular.element(elementId.sidebarWrapper).width();
            resizeService.resizeToOrginalSize();
        };

        function _resizeSidebarWithRememberedChangedWidth() {
            if (vm.rememberedChangedWidth != 0 && vm.rememberedChangedWidth != 320) {
                resizeService.resizeToChangedSize(vm.rememberedChangedWidth);
            }
        };

        function openMyReadingReceipt() {
            var modalInstance = $uibModal.open({
                templateUrl: '/app/components/home/templates/myReadingReceipts.html',
                controller: controllers.myReadingReceiptsController + ' as vm',
                size: 'lg',
                resolve: {
                    items: function () {
                    }
                }
            });
        };

        function changePassword() {
            var modalInstance = $uibModal.open({
                templateUrl: '/app/components/account/templates/changePassword.html',
                controller: 'ChangePasswordController as vm',
                size: 'md'
            });
        }

        let currentTabPromise = undefined;
        // 0: active tab	1: upcoming tab
        function onChangeActivityNotifyTab(value) {
            if (vm.currentActivityNotifyTab === value)
                return;

            if (currentTabPromise) {
                currentTabPromise.cancel();
                currentTabPromise = undefined;
            }
            
            vm.activitiesNotify = [];
            currentPageIndexNotifyAc = 1;
            vm.currentActivityNotifyTab = value;
            currentTabPromise = getActivitiesForNotifyPromise();

            setTimeout(() => {
                vm.calendarChangeTabLoading = true;
                currentTabPromise.promise.then(res => {
                    vm.calendarChangeTabLoading = false;
                    vm.activitiesNotify = res.data;
                    observableScrollModal();
                }).catch(() => vm.calendarChangeTabLoading = false);
            }, 0);
        }

        function getActivitiesForNotifyPromise(pageIndex = 1) {
            switch (vm.currentActivityNotifyTab) {
                case 0:
                    return getActiveActivitiesForNotification(pageIndex);
                case 1:
                    return getUpcomingActivities(pageIndex);
                default:
                    throw Error('invalid tab')
            }
        }

        function getActiveActivitiesForNotification(pageIndex = 1) {
            const def = $q.defer();
            const cancel = function () {
                def.resolve();
            };

            const promise = $http.get('/api/Activity/GetActiveActivitiesForNotification', {
                params: {
                    pageIndex: pageIndex
                },
                timeout: def.promise
            }).then(function (response) {
                return response.data;
            });

            return {
                promise: promise,
                cancel: cancel
            };
        }

        function getUpcomingActivities(pageIndex = 1) {
            const def = $q.defer();
            const cancel = function () {
                def.resolve();
            };

            const promise = $http.get('/api/Activity/GetUpcomingActivities', {
                params: {
                    pageIndex: pageIndex
                },
                timeout: def.promise
            }).then(function (response) {
                return response.data;
            });

            return {
                promise: promise,
                cancel: cancel
            };
        }

        function getActiveActivitiesForNotificationCounter() {
            $http.get('/api/Activity/GetActiveActivitiesForNotificationCounter').then(res => {
                vm.activeActivityCounter = res.data;
            });
        }

        function toggleActivities(event) {
            stopPropagation(event);
            const element = angular.element('.activity-notifications > div');
            if (!element)
                return;

            const visible = element.css('display') == 'block';
            angular.element('#sidebar_right').css('display', 'none');

            if (visible)
                return element.css('display', 'none');

            currentPageIndexNotifyAc = 1;
            vm.calendarLoading = true;

            getActivitiesForNotifyPromise().promise.then(res => {
                vm.activitiesNotify = res.data;
                vm.calendarLoading = false;
                if (vm.activitiesNotify.length) {
                    element.css('display', 'block');
                    observableScrollModal();
                }
            }).catch(() => {
                vm.calendarLoading = false;
            });
        }

        let loadMorePromise;
        function observableScrollModal() {
            angular.element("#activityCalendarModal").scrollTop(0);
            setTimeout(() => {
                const activityModal = angular.element("#activityCalendarModal");
                if (!activityModal)
                    return;
                activityModal.scrollTop(0);

                activityModal.ready(
                    function () {
                        activityModal.off('scroll');
                        activityModal.scroll(
                            function () {
                                const limit = activityModal.prop('scrollHeight') - activityModal.prop('clientHeight');
                                if (limit === activityModal.scrollTop()) {
                                    if (loadMorePromise)
                                        return;
                                    loadMorePromise = getActivitiesForNotifyPromise(currentPageIndexNotifyAc + 1);
                                    vm.calendarLoadingMore = true;
                                    loadMorePromise.promise.then(
                                        res => {
                                            vm.calendarLoadingMore = false;
                                            loadMorePromise = null;
                                            currentPageIndexNotifyAc = res.pageIndex;
                                            vm.activitiesNotify = [...vm.activitiesNotify, ...res.data];
                                        }
                                    ).catch(() => vm.calendarLoadingMore = false);
                                }
                            }
                        );
                    }
                );
            }, 0);
        }


        function editActivity(activity) {
            angular.element('.activity-notifications > div').css('display', 'none');
            if (configService.getBool(HandbookConfiguration.ShowNewAnnualCycleDetailPage)) {
                window.open(String.format('/ac/activity/{0}', activity.activityId));
                return;
            }
            if (!vm.annualCyclePermissions) {
                $http
                    .get('/api/AnnualCycle/GetAnnualCyclePermission')
                    .success(function (data) {
                        vm.annualCyclePermissions = data; 
                        navigateToEditActivityBackend(activity);
                    });
                return;
            }
            navigateToEditActivityBackend(activity);
        }

        function navigateToEditActivityBackend(activity) {
            window.open(vm.annualCyclePermissions.annualCycleAdmin ? 
                String.format('{0}ac/annualCycle/activities/{1}/edit', HandbookConfiguration.BackendURL, activity.activityId) :
                String.format('{0}ac/activity/{1}/edit', HandbookConfiguration.BackendURL, activity.activityId)
            )
        }

        function stopPropagation(event) {
            if (event) {
                event.stopPropagation();
            }
        }

        function openAboutDialog() {
            $uibModal.open({
                templateUrl: '/app/components/home/templates/about.html',
                controller: 'AboutController as vm',
                size: 'md'
            });
        }

        hotkeys.bindTo($scope)
            .add({
                combo: shortcutKeysService.gotoStartpage.shortcut,
                description: 'Open start page', // The description just explain in code, not use in GUI
                callback: shortcutKeysService.gotoStartpage.method
            })
            .add({
                combo: shortcutKeysService.openFavouritesMenu.shortcut, // because shilf+alt+f is hotkey of browser, so we use ctrl instead.
                description: 'Open faviroute sidebar',
                callback: shortcutKeysService.openFavouritesMenu.method
            })
            .add({
                combo: shortcutKeysService.openDocumentsMenu.shortcut,
                description: 'Open document sidebar',
                callback: shortcutKeysService.openDocumentsMenu.method
            })
            .add({
                combo: shortcutKeysService.openSimpleSearch.shortcut,
                description: 'Open simple search. Set focus on search field in top bar so user can start typing',
                callback: shortcutKeysService.openSimpleSearch.method
            })
            .add({
                combo: shortcutKeysService.navigateItemInSidebar.shortcut,
                description: 'Navigate folder in folder view.',
                callback: shortcutKeysService.navigateItemInSidebar.method
            })
            .add({
                combo: shortcutKeysService.printFolderPDFIndex.shortcut,
                description: 'Print folder/document index PDF',
                callback: function () {
                    var url = $location.url();
                    if (url.indexOf('folder') > 0) {
                        shortcutKeysService.printFolderPDFIndex.method();
                    } else if (url.indexOf('document') > 0) {
                        shortcutKeysService.printDocumentPDFA4.method();
                    }
                }
            })
            .add({
                combo: shortcutKeysService.toggleFavorite.shortcut,
                description: 'Toggle folder favorite',
                callback: shortcutKeysService.toggleFavorite.method
            })
            .add({
                combo: shortcutKeysService.toggleEmailNotification.shortcut,
                description: 'Toggle email subscription',
                callback: shortcutKeysService.toggleEmailNotification.method
            })
            .add({
                combo: shortcutKeysService.toggleOnlyFolderEmailNotification.shortcut,
                description: 'Toggle only folder email subscription',
                callback: shortcutKeysService.toggleOnlyFolderEmailNotification.method
            })
            .add({
                combo: shortcutKeysService.openGridSetting.shortcut,
                description: 'Open grid settings. First column should have focus so user can use space to toggle and tab to go to next one',
                callback: shortcutKeysService.openGridSetting.method
            })
            .add({
                combo: shortcutKeysService.toggleFolderContentTab.shortcut,
                description: 'Toggle folder/document content tab',
                callback: function () {
                    var url = $location.url();
                    if (url.indexOf('folder') > 0) {
                        shortcutKeysService.toggleFolderContentTab.method();
                    } else if (url.indexOf('document') > 0) {
                        shortcutKeysService.toggleDocumentContentTab.method();
                    } else {
                        shortcutKeysService.toggleMasterHomeTab.method();
                    }
                }
            })
            .add({
                combo: shortcutKeysService.toggleFolderAboutTab.shortcut,
                description: 'Toggle folder/document about tab',
                callback: function () {
                    var url = $location.url();
                    if (url.indexOf('folder') > 0) {
                        shortcutKeysService.toggleFolderAboutTab.method();
                    } else if (url.indexOf('document') > 0) {
                        shortcutKeysService.toggleDocumentAboutTab.method();
                    } else {
                        shortcutKeysService.toggleWhatsNewsTab.method();
                    }
                }
            })
            .add({
                combo: shortcutKeysService.toggleDocumentMetadataTab.shortcut,
                description: 'Toggle metadata if enabled',
                callback: function () {
                    var url = $location.url();
                    if (url.indexOf('document') > 0) {
                        if (configService.getBool(HandbookConfiguration.MetadataEnabled)) {
                            shortcutKeysService.toggleDocumentMetadataTab.method();
                        } else {
                            shortcutKeysService.toggleDocumentSearchInContentTab.method();
                        }
                    } else {
                        shortcutKeysService.toggleUpdatedFavoriteTab.method();
                    }
                }
            })
            .add({
                combo: shortcutKeysService.toggleDocumentSearchInContentTab.shortcut,
                description: 'Toggle metadata if enabled',
                callback: function () {
                    var url = $location.url();
                    if (url.indexOf('document') > 0) {
                        if (configService.getBool(HandbookConfiguration.MetadataEnabled)) {
                            shortcutKeysService.toggleDocumentSearchInContentTab.method();
                        }
                    } else if (configService.getBool(HandbookConfiguration.ReadingListEnabled)) {
                        shortcutKeysService.toggleMyReadingListTab.method();
                    }
                }
            })
            .add({
                combo: shortcutKeysService.openDocumentReadingReceipt.shortcut,
                description: 'Open reading receipt',
                callback: shortcutKeysService.openDocumentReadingReceipt.method
            })
            .add({
                combo: shortcutKeysService.openDocumentFeedback.shortcut,
                description: 'Open feedback',
                callback: shortcutKeysService.openDocumentFeedback.method
            })
            .add({
                combo: shortcutKeysService.toggleDocumentFullScreenViewing.shortcut,
                description: 'Toggle fullscreen viewing',
                callback: shortcutKeysService.toggleDocumentFullScreenViewing.method
            })
            .add({
                combo: shortcutKeysService.linkToDocumentManagement.shortcut,
                description: 'Link to document management',
                callback: function () {
                    var url = $location.url();
                    if (url.indexOf('folder') > 0) {
                        shortcutKeysService.linkToFolderManagement.method();
                    } else if (url.indexOf('document') > 0) {
                        shortcutKeysService.linkToDocumentManagement.method();
                    }
                }
            });

        $(window).keyup(function (event) { // handle number 0 on number pad
            if (event.ctrlKey && event.altKey && event.keyCode == 96) {
                shortcutKeysService.gotoStartpage.method();
            }
        });

        $(window).on('resize', function () {
            resizeService.resizeToOrginalSize();
            if (vm.isTest) {
                updatePositionForTestModeHeader();
            }
        });

        $(window).on('click', function () {
            angular.element('.activity-notifications > div').css('display', 'none');
        })

        function updatePositionForTestModeHeader() {
            var widthOfDocument = $(document).width();
            var widthOfToggleSidebarButton = 42;
            var widthOfSearchDocumentsControl = 280;
            var widthOfLeftControls = widthOfToggleSidebarButton + widthOfSearchDocumentsControl;
            var widthOfTestModeHeader = 50;
            var widthOfRightMenu = $('#navbar-header .navbar-right').width();
            var remainingWidth = widthOfDocument - widthOfLeftControls - widthOfTestModeHeader - widthOfRightMenu;

            $('#navbar-header .test-mode-header').css('left', (remainingWidth) / 2 + widthOfLeftControls);

        }

        function keydown(e) {
            if (e.which === 112) {
                if (vm.helpEnabled) {
                    document.onhelp = function () {
                        return (false);
                    };
                    window.onhelp = function () {
                        return (false);
                    };
                    e.returnValue = false;
                    e.keyCode = 0;
                    e.preventDefault();
                    e.stopPropagation();
                    goToHelpPages();
                    return false;
                }
            }
        }

        function goToHelpPages() {
            if (vm.helpEnabled) {
                var urlParams = $location.url().split('/');
                var viewId = 1;
                if (urlParams != null && urlParams.length > 0) {
                    switch (urlParams[1]) {
                        case 'folder':
                            viewId = 2;
                            break;
                        case 'document':
                            viewId = 3;
                            break;
                        case '':
                            if (angular.element('#hearings-tab').hasClass('active')) {
                                viewId = 4;
                            }
                            break;
                        default:
                            viewId = 1;
                    }
                }
                var newWindow = window.open("", "_blank");
                helpPagesService.getHelpPages(viewId).then(function (data, status, headers, config) {
                    newWindow.location.href = data.helpURL;
                });
            }
        }
    };
})();